var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footerCopy"},[_c('span',[_vm._v("Copyright © "+_vm._s((new Date()).getFullYear())+" 臭豆腐電影")]),_c('router-link',{attrs:{"to":"/privacypolicy"}},[_vm._v("Privacy Policy")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }